/**
 * header-focus-trap.js — minimal Tab-wrap focus trap for the header dialogs.
 * trapFocus(container) → release(). No library, no sentinel nodes.
 */

const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]';

function visibleFocusables(container) {
    return [...container.querySelectorAll(FOCUSABLE)].filter(
        (el) =>
            el.offsetParent !== null &&
            !el.hasAttribute('hidden') &&
            getComputedStyle(el).visibility !== 'hidden', // off-canvas subpanels
    );
}

export default function trapFocus(container) {
    function onKeydown(e) {
        if (e.key !== 'Tab') return;

        const focusables = visibleFocusables(container);
        if (focusables.length === 0) return;

        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        const active = document.activeElement;

        if (e.shiftKey && (active === first || !container.contains(active))) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && active === last) {
            e.preventDefault();
            first.focus();
        }
    }

    container.addEventListener('keydown', onKeydown);
    return function release() {
        container.removeEventListener('keydown', onKeydown);
    };
}
